import { slabvsusedpoints } from 'app/api/report';
import Message from 'app/utils/Message';
import Toast from 'app/utils/Toast';
import { useCallback, useEffect, useState } from 'react';

const useSlabVsUsedPoints = ({values}) => {

  const [pageLoading, setPageLoading] = useState(false);
  const [graphData, setGraphData] = useState([]); 

  useEffect(() => {
    GetSlabVsEarnPoints(values);
  }, [values]);


  const GetSlabVsEarnPoints = useCallback(
    async (filters = {}) => {
      // if(!filters.mallId || !filters.startDate || !filters.endDate ){
      //   return;
      // }
      setPageLoading(true);
      try {
        let requestParams = {
          mallId:filters.mallId,
          startDate: filters.startDate,
          endDate: filters.endDate,
        };

        const response = await slabvsusedpoints(requestParams);
        if (response?.responseCode === 200) {
    
      setGraphData(response?.data);
        } else {
          Toast.error(
            response?.response?.message || Message.Error.COMMON_MESSAGE
          );
        }
      } catch (error) {
        Toast.error(Message.Error.COMMON_MESSAGE);
      } finally {
        setPageLoading(false);
      }
    },
    []
  );
  
  return {
    pageLoading,
    graphData,

  };
};

export default useSlabVsUsedPoints;
